import { css } from 'styled-components';
export default {
    brandonGrotesque: {
        thin: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: normal;
      font-weight: 100;
    `,
        thinItalic: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: italic;
      font-weight: 100;
    `,
        light: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: italic;
      font-weight: 300;
    `,
        regular: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: italic;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: italic;
      font-weight: 500;
    `,
        bold: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: italic;
      font-weight: 700;
    `,
        black: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: normal;
      font-weight: 900;
    `,
        blackItalic: css `
      font-family: 'Brandon Grotesque', sans-serif;
      font-style: italic;
      font-weight: 900;
    `,
    },
    zahrah: {
        regular: css `
      font-family: 'Zahrah', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'Zahrah', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        semiBold: css `
      font-family: 'Zahrah', sans-serif;
      font-style: normal;
      font-weight: 600;
    `,
    },
};
